import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { Spin, notification, Input } from "antd";
import { useSelector } from "react-redux";
import { apiRequest } from "util/services";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { BookOutlined, SearchOutlined } from "@ant-design/icons";
import Listing from "./Listing/Listing";

const FollowedTopics = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [topicList, setTopicList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchWord, setSearchWord] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchListing();
  }, []);

  const fetchListing = async () => {
    setLoading(true);
    setError(null);
    const result = await apiRequest(
      "topic_tracker/get_topic_tracker",
      "POST",
      null,
      true
    );
    if (result?.data) {
      setTopicList(result.data);
      setFilteredList(result.data);
    } else if (!result?.cancel) {
      const errMsg = result?.error || "Failed to load followed topics";
      setError(errMsg);
      notification.error({ message: errMsg });
    }
    setLoading(false);
  };

  const handleSearch = (value) => {
    setSearchWord(value);
    if (value.trim()) {
      const filtered = topicList.filter((item) =>
        (item.topic_name || "").toLowerCase().includes(value.toLowerCase()) ||
        (item.dashboard_name || "").toLowerCase().includes(value.toLowerCase())
      );
      setFilteredList(filtered);
    } else {
      setFilteredList(topicList);
    }
  };

  return (
    <div className={styles.tabContent}>
      {/* Toolbar: only show when there are topics */}
      {topicList.length > 0 && (
        <div className={styles.toolbar}>
          <p className={styles.count}>{topicList.length} topic{topicList.length !== 1 ? "s" : ""} followed</p>
          <Input
            prefix={<SearchOutlined style={{ color: "var(--color4)" }} />}
            placeholder="Search by topic or dashboard..."
            value={searchWord}
            onChange={(e) => handleSearch(e.target.value)}
            className={styles.searchInput}
            allowClear
          />
        </div>
      )}

      {loading ? (
        <div className={styles.loadingWrapper}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <div className={styles.emptyState}>
          <p className={styles.emptyTitle}>Something went wrong</p>
          <p className={styles.emptySubtitle}>{error}</p>
          <button className={styles.outlineBtn} onClick={fetchListing}>
            Try again
          </button>
        </div>
      ) : filteredList.length === 0 && searchWord ? (
        <div className={styles.emptyState}>
          <SearchOutlined className={styles.emptyIcon} />
          <p className={styles.emptyTitle}>No results for "{searchWord}"</p>
          <p className={styles.emptySubtitle}>Try a different topic or dashboard name.</p>
        </div>
      ) : topicList.length === 0 ? (
        <div className={styles.emptyState}>
          <BookOutlined className={styles.emptyIcon} />
          <p className={styles.emptyTitle}>No followed topics yet</p>
          <p className={styles.emptySubtitle}>
            Follow topics from Custom Topics to receive daily notifications.
          </p>
          <button
            className={styles.primaryBtn}
            onClick={() => history.push("/settings/topic-library?tab=custom")}
          >
            Browse Custom Topics
          </button>
        </div>
      ) : (
        <Listing list={filteredList} fetchList={fetchListing} />
      )}
    </div>
  );
};

export default FollowedTopics;
